export default {
  // Left Menu Admin
  "configLeftMenuAdmin.add": "Add",
  "configLeftMenuAdmin.details": "Details",
  "configLeftMenuAdmin.edit": "Edit",
  "configLeftMenuAdmin.delete": "Delete",
  "configLeftMenuAdmin.delete.confirm.title": "Delete Configuration",
  "configLeftMenuAdmin.delete.confirm.content": "Are you sure you want to delete this configuration?",
  "configLeftMenuAdmin.delete.confirm.okText": "Confirm",
  "configLeftMenuAdmin.delete.confirm.cancelText": "Cancel",
  "configLeftMenuAdmin.modal.title": "Left Menu Configuration",
  "configLeftMenuAdmin.thead.createdAt": "Created At",
  "configLeftMenuAdmin.thead.updatedAt": "Updated At",
  "configLeftMenuAdmin.thead.action": "Action",

  // Left Menu fields
  "configLeftMenuAdmin.thead.id": "ID",
  "configLeftMenuAdmin.thead.title": "Title",
  "configLeftMenuAdmin.thead.url": "URL",
  "configLeftMenuAdmin.thead.activeKey": "Active Key",
  "configLeftMenuAdmin.thead.parentId": "Parent ID",
  "configLeftMenuAdmin.thead.type": "Type",
  "configLeftMenuAdmin.thead.ItemId": "Item ID",
  "configLeftMenuAdmin.thead.params": "Params",
  "configLeftMenuAdmin.thead.iconUrl": "Icon URL",
  "configLeftMenuAdmin.thead.sort": "Sort",
  "configLeftMenuAdmin.thead.hideMenu": "Hide Menu",
  "configLeftMenuAdmin.thead.seo": "SEO",
  "configLeftMenuAdmin.thead.loginToDirect": "Login To Direct",
  "configLeftMenuAdmin.thead.siteKey": "Site Key",
  "configLeftMenuAdmin.thead.bindSite": "Bind Site",
  "configLeftMenuAdmin.thead.setDefaultData": "Set Default Data",
  "configLeftMenuAdmin.thead.deviceType": "Device Type",
  "configLeftMenuAdmin.thead.documentId": "Document ID",
  "configLeftMenuAdmin.thead.createdBy": "Created By",
  "configLeftMenuAdmin.thead.updatedBy": "Updated By"
};